import { render, staticRenderFns } from "./AddLinkMenuButton.vue?vue&type=template&id=b9a6115e"
import script from "./AddLinkMenuButton.vue?vue&type=script&lang=js"
export * from "./AddLinkMenuButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports